import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrdersComponent } from './orders/orders.component';
import { DispatchDashboardComponent } from './dispatch-dashboard/dispatch-dashboard.component';
import { LoginComponent } from './navigation/login/login.component';
import { DriversComponent } from './drivers/drivers.component';
import { EquipmentComponent } from './equipment/equipment.component';
import { CustomersComponent } from './customers/customers.component';
import { DriversScheduleComponent } from './drivers-schedule/drivers-schedule.component';
import { AuthGuard } from './routing/auth.guard';
import { CustomerLoadDetailsComponent } from './customers/customer-load-details/customer-load-details.component';
import { ManageDriversComponent } from './manage-drivers/manage-drivers.component';
import { OrderCalendarComponent } from './order-calendar/order-calendar/order-calendar.component';


const routes: Routes = [
  {
    path: '', 
    redirectTo: '/dispatch_dash', 
    pathMatch: 'full' 
  },
  {
    path: 'login', 
    component: LoginComponent 
  },
  {
    path: 'orders',
    component: OrdersComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'order-calendar',
    component: OrderCalendarComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'dispatch_dash',
    component: DispatchDashboardComponent,
    data: { showCalendar: true },
    canActivate: [AuthGuard]
  },
  {
    path: 'drivers',
    component: DriversComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'equipment',
    component: EquipmentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'customers',
    component: CustomersComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'driver-schedule/:driverId',
    component: DriversScheduleComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'customer-load-details/:id',
    component: CustomerLoadDetailsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'manage-drivers',
    component: ManageDriversComponent,
    canActivate: [AuthGuard]
  },
  { 
    path: 'callback', 
    component: LoginComponent 
  },
  { 
    path: '**', 
    redirectTo: 'dispatch_dash', 
    pathMatch: 'full' 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


